let lastSelectedIndex = 0;

function initHeroSlider(root = document) {
  const el = root.querySelector("#my-slider");
  if (!el || el.dataset.splideMounted) return;

  const slides = el.querySelectorAll(".splide__slide");
  const multi = slides.length > 1;
  const auto = el.dataset.autoplay === "true";

  let splide;

  if (Shopify.designMode) {
    // Editor-safe mode (no autoplay, no snapping)
    splide = new Splide(el, {
      type: "slide",
      arrows: multi,
      pagination: multi,
      drag: multi,
      keyboard: multi,
      autoplay: false,
      speed: 0,
      start: null,
      updateOnMove: false,
      perPage: 1,
    });
  } else {
    // Live mode
    splide = new Splide(el, {
      type: multi ? "loop" : "slide",
      arrows: true,
      pagination: multi,
      drag: multi,
      keyboard: multi,
      autoplay: auto,
      perPage: 1,
    });
  }

  splide.mount();

  if (Shopify.designMode && lastSelectedIndex > 0) {
    splide.go(lastSelectedIndex);
  }

  // store the instance for block:select
  el._splide = splide;
  el.dataset.splideMounted = "true";
}

document.addEventListener("DOMContentLoaded", () => {
  initHeroSlider();

  // Theme Editor dynamic section loading
  document.addEventListener("shopify:section:load", (e) => {
    initHeroSlider(e.target);
  });
});

// Sync slide when clicking a block in the customizer
document.addEventListener("shopify:block:select", (e) => {
  const blockId = e.detail.blockId;
  const el = document.querySelector("#my-slider");
  const splide = el?._splide;
  if (!splide) return;

  const slides = [...el.querySelectorAll(".splide__slide")];
  const index = slides.findIndex((slide) => slide.dataset.blockId === blockId);

  if (index >= 0) {
    lastSelectedIndex = index;
    splide.go(index);
  }
});

// Optional: reset to slide 1 when no block is selected
// document.addEventListener("shopify:block:deselect", () => {
//   const el = document.querySelector("#my-slider");
//   const splide = el?._splide;
//   if (splide && Shopify.designMode) splide.go(0);
// });

// Restore last selected slide in editor

// === Connect custom arrows ===
// document.addEventListener("DOMContentLoaded", () => {
//   const slider = document.querySelector("#my-slider")?._splide;
//   if (!slider) return;

//   document.querySelector(".hero-arrow--prev")?.addEventListener("click", () => {
//     slider.go("<");
//   });

//   document.querySelector(".hero-arrow--next")?.addEventListener("click", () => {
//     slider.go(">");
//   });
// });

document.addEventListener("DOMContentLoaded", function () {
  new Splide(".products-splide", {
    type: "loop",
    perPage: 6,
    perMove: 1,
    gap: "1.5rem",
    pagination: true,
    arrows: true,
    breakpoints: {
      1280: { perPage: 5 },
      1024: { perPage: 4 },
      768: { perPage: 3 },
      640: { perPage: 2 },
      480: {
        perPage: 1,
        padding: { left: 0, right: "20%" },
        gap: "1rem",
      },
    },
  }).mount();

  document.querySelectorAll(".blog-splide").forEach(function (el) {
    new Splide(el, {
      type: "loop",
      perPage: 3,
      perMove: 1,
      gap: "1.5rem",
      pagination: true,
      arrows: true,
      breakpoints: {
        1024: { perPage: 2, perMove: 1 },
        768: {
          perPage: 2,
          perMove: 1,
          arrows: false,
          padding: { left: 0, right: "12%" },
          gap: "0.8rem",
        },
        420: {
          perPage: 1,
          perMove: 1,
          arrows: false,
          padding: { left: 0, right: "20%" },
          gap: "0.8rem",
        },
      },
    }).mount();
  });

  document.querySelectorAll(".four-col-splide").forEach(function (el) {
    var splide = new Splide(el, {
      type: "loop",
      perPage: 4,
      perMove: 1,
      gap: "1.2rem",
      pagination: true,
      arrows: false,
      autoplay: false,
      interval: 8000,
      pauseOnHover: true,
      speed: 1200,
      easing: "cubic-bezier(0.25, 1, 0.5, 1)",
      drag: true,
      snap: true,
      flickPower: 300,
      padding: { left: 0, right: "8%" },
      breakpoints: {
        1280: { perPage: 3, padding: { left: 0, right: "10%" } },
        1024: { perPage: 2, padding: { left: 0, right: "12%" } },
        768: {
          perPage: 2,
          gap: "0.8rem",
          padding: { left: 0, right: "12%" },
        },
        480: {
          perPage: 1,
          gap: "0.8rem",
          padding: { left: 0, right: "20%" },
        },
      },
    }).mount();

    // Auto-slide when scrolled into viewport
    var started = false;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !started) {
            started = true;
            setTimeout(function () {
              splide.go(">");
              splide.Components.Autoplay.play();
            }, 3000);
          }
        });
      },
      { threshold: 0.05 },
    );
    observer.observe(el);
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const inStock = document
    .querySelector(".availability-wrapper span:not(.circle)")
    ?.textContent?.trim();

  if (inStock === "Product not available") {
    document
      .querySelector(".product__availability .circle")
      ?.style.setProperty("color", "#d51b1bff", "important");

    document
      .querySelector(".product__availability span:not(.circle)")
      ?.style.setProperty("color", "#d51b1bff", "important");

    document
      .querySelector(".availability-wrapper .circle")
      ?.style.setProperty("color", "#d51b1bff", "important");

    document
      .querySelector(".availability-wrapper span:not(.circle)")
      ?.style.setProperty("color", "#d51b1bff", "important");
  }
});

// Header search: hide icons/label when focused or typing, show when empty and not focused
document.addEventListener("DOMContentLoaded", function () {
  const headerSearchInputs = document.querySelectorAll(
    ".header__search .search__input.field__input",
  );

  headerSearchInputs.forEach(function (input) {
    const field = input.closest(".field");
    if (!field) return;

    const searchBtn = field.querySelector(".search__button");
    const resetBtn = field.querySelector(".reset__button");
    const label = field.querySelector(".field__label");

    function updateVisibility() {
      const hasText = input.value.length > 0;
      const isFocused = document.activeElement === input;

      if (searchBtn)
        searchBtn.style.display = hasText || isFocused ? "none" : "";
      if (label) label.style.display = hasText || isFocused ? "none" : "";
      if (resetBtn) resetBtn.style.display = hasText ? "flex" : "none";
    }

    input.addEventListener("input", updateVisibility);
    input.addEventListener("focus", updateVisibility);
    input.addEventListener("blur", updateVisibility);

    // Initial check
    updateVisibility();
  });
});

// Heart logic

const STORAGE_KEY = "heart-wishlist";

const parseFavorites = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
  } catch (err) {
    console.error("Wishlist parse error", err);
    return [];
  }
};

const normalizeFavorites = (list) => {
  if (!Array.isArray(list)) return [];
  const now = Date.now();
  let offset = 0;
  const normalized = list
    .map((entry) => {
      if (typeof entry === "string") {
        return { handle: entry, timestamp: now - offset++ };
      }
      return {
        handle: entry.handle,
        timestamp: Number(entry.timestamp) || now - offset++,
      };
    })
    .filter((entry) => entry.handle)
    .sort((a, b) => Number(b.timestamp) - Number(a.timestamp));

  const seen = new Set();
  return normalized.filter((entry) => {
    if (seen.has(entry.handle)) return false;
    seen.add(entry.handle);
    return true;
  });
};

let favorites = normalizeFavorites(parseFavorites());

const persistFavorites = () => {
  favorites = normalizeFavorites(favorites);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(favorites));
  console.log(
    "heart-wishlist:",
    favorites.map((fav) => fav.handle),
  );
};

if (favorites.length) persistFavorites();

function syncHearts() {
  document
    .querySelectorAll(".card__badges-top .fa-heart[data-product-handle]")
    .forEach((icon) => {
      const handle = icon.dataset.productHandle;
      const active = favorites.some((fav) => fav.handle === handle);
      icon.classList.toggle("is-active", active);
      icon.classList.toggle("fa-solid", active);
      icon.classList.toggle("fa-regular", !active);
    });
}

window.syncHearts = syncHearts;

document.addEventListener("DOMContentLoaded", syncHearts);
document.addEventListener("shopify:section:load", syncHearts);

document.addEventListener("click", (e) => {
  const icon = e.target.closest(".card__badges-top .fa-heart");
  if (!icon) return;
  e.preventDefault();
  e.stopPropagation();
  const handle = icon.dataset.productHandle;
  const index = favorites.findIndex((fav) => fav.handle === handle);
  const wasLiked = index > -1;
  const toggledAt = Date.now();

  if (wasLiked) {
    favorites.splice(index, 1);
  } else {
    favorites.push({ handle, timestamp: toggledAt });
  }

  persistFavorites();
  syncHearts();

  if (wasLiked) {
    // Removal — dispatch targeted event so wishlist page can remove just that card
    window.dispatchEvent(
      new CustomEvent("wishlist:item-removed", { detail: { handle } }),
    );
  } else {
    // Addition — full re-render needed to add the new card
    window.dispatchEvent(new CustomEvent("wishlist:updated"));
  }

  if (window.sbWishlist?.onToggle) {
    window.sbWishlist.onToggle(handle, !wasLiked, toggledAt);
  }
});

/* ── Wishlist "added!" tooltip on announcement bar button ── */
window.addEventListener("wishlist:updated", () => {
  const btn = document.querySelector(".wish-list-button");
  if (!btn) return;
  btn.classList.add("added");
  setTimeout(() => btn.classList.remove("added"), 1500);
});

/* ── Copy link button on article page ── */
document.addEventListener("click", function (e) {
  const btn = e.target.closest(".article-page__copy-link");
  if (!btn) return;
  const url = window.location.href;
  if (navigator.clipboard) {
    navigator.clipboard.writeText(url).then(function () {
      btn.classList.add("copied");
      setTimeout(function () {
        btn.classList.remove("copied");
      }, 2000);
    });
  }
});
